import React from "react";
import Grid from "@material-ui/core/Grid";
import MaterialTable from "material-table";
import { stElemnt } from "../../../St/Reviews/cStyle";
import { colors} from "@material-ui/core";
import { useRptAF } from "../../../St/Reviews/UseStyle";
const Body = (props) => {
  const {  data, num } = props;
  const cls = useRptAF();
  const cellS = {
    padding: "0px 2px",
    textAlign: "-webkit-center",
    margin: "0px",
    whiteSpace: "normal",
    border: "solid 0.1px",
    fontSize: "0.8rem",
    width: "32%",
    fontFamily: "Amiri-Regular",
    fontWeight: "bold",
  };

  var columns2 = [
    { title: "Item Name \n اسم الصنف", field: "symbol", cellStyle: cellS },
    { title: "Unit \n الوحدة", field: "unit_name", },
    { title: "Quantity \n الكمية ", field: "val1" },
    { title: "Price \n السعر ", field: "new_exchange_price", },
    { title: "NetAmount \n الاجمالي ", field: "tot_net_curr" },
  ];
  var columns = [
    { title: "Item Name \n اسم الصنف", field: "symbol", cellStyle: cellS },
    { title: "Unit \n الوحدة", field: "unit_name", },
    { title: "Qoantity \n الكمية ", field: "val1" },
    { title: "Price \n السعر ", field: "new_exchange_price", },
    { title: "Discount \n الخصم ", field: "discount" },
    { title: "Vat Perc \n %الضريبة ", field: "taxperc" },
    { title: "NetAmount \n الاجمالي شامل الضريبة ", field: "tot_net_curr" },
  ];

  return (
    <Grid item container className={cls.rootBdy} style={{ direction: "ltr" }}>
      <Grid item container //className={cls.rootBdyup}
        style={{
          paddingTop: "0.5rem", direction: "rtl",
        }}>
        <Grid
          item
          xs={12}
        >
          <MaterialTable
            style={{ boxShadow: "none", width: "100%", tableLayout: "fixed" }}
            options={{
              showTitle: false,
              toolbar: false,
              sorting: false,
              selection: false,
              // ToolBar Search
              searchFieldAlignment: "left",
              searchFieldVariant: "outlined",
              // ToolBar header
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              pageSize: 5,
              paginationType: "stepped",
              showFirstLastPageButtons: false,

              headerStyle: {
                ...stElemnt.AF.header,
                backgroundColor: colors.grey[100],
                fontWeight: "bold",
                paddingTop: "2px",
                paddingBottom: "2px",
                border: "solid 0.1px",
                fontSize: "1rem",


              },
              paging: false,
              cellStyle: {
                ...stElemnt.AF.cell,
                padding: "0px 2px",
                fontSize: "1rem",
                fontWeight: "bold"
              },
            }}
            localization={{ body: { emptyDataSourceMessage: <h1></h1> } }}
            columns={num== 7 ? columns2.map(column => ({
              ...column,
              title: column.title.split("\n").map((line, index) => (
                <div key={index}>{line}</div>
              )),

            })) :
              columns.map(column => ({
                ...column,
                title: column.title.split("\n").map((line, index) => (
                  <div key={index}>{line}</div>
                )),

              }))
            }
            data={data}
          />
        </Grid>

      </Grid>

    </Grid>
  );
};

export default Body;
